module.exports = __webpack_public_path__ + "static/media/5DPO3.8fe93493.jpg";